import { format } from 'fecha';
import isEmpty from 'lodash/isEmpty';
import memoize from 'lodash/memoize';
import { _label } from '../vernacular/AppLanguage';

export const getHeaderTitle = (originStation, destinationStation) => {
  const origin = isEmpty(originStation.cityName) ?
    (isEmpty(originStation.stationName)?originStation.code:originStation.stationName) : originStation.cityName;
  const dest = isEmpty(destinationStation.cityName) ?
  (isEmpty(destinationStation.stationName)?destinationStation.code:destinationStation.stationName) : destinationStation.cityName;
  return _label("origin_to_dest", undefined, { origin, dest })
};

export const getHeaderSubtitle = (journeyDate) => {
  // TODO Vernac this is failing.
  return format(journeyDate, "DD MMM, dddd");
};

export const getHeaderTitleForTravelersAndReview = (selectedTrainInfo) => {
  const origin = selectedTrainInfo?.frmStnCity || selectedTrainInfo?.frmStnName;
  const dest = selectedTrainInfo?.toStnCity || selectedTrainInfo?.toStnName;
  return _label('origin_to_dest', undefined, { origin, dest });
};
